<template>
  <nav>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      persistent
    >
      <template
        v-if="canEditProfile"
        v-slot:activator="{ on, attrs }"
      >
        <v-btn
          data-testid="edit-name-button"
          v-bind="attrs"
          icon
          absolute
          right
          top
          class="mt-n2 mr-n2"
          v-on="on"
          @click="$emit('proceedSubmit', '', '')"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
      <v-card data-testid="edit-user-card">
        <v-form
          ref="form"
          v-model="valid"
          @keyup.enter="updateFirstLastName"
          @submit.prevent
        >
          <v-toolbar
            dark
            color="accent"
          >
            <v-btn
              data-testid="close-button"
              icon
              dark
              @click="reloadForm"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title class="text-h5 font-weight-bold">
              {{ $t('editUserNameTitle') }}
            </v-toolbar-title>
            <v-spacer />
            <v-btn
              data-testid="submit-button"
              type="submit"
              :disabled="loading"
              color="white"
              class="text-body-1 darktext--text text-none rounded-xxl px-4"
              @click="updateFirstLastName"
            >
              {{ $t('save') }}
            </v-btn>
          </v-toolbar>
          <AlertMessages
            v-if="alertValue"
            alert-type="error" 
            :alert-msg="alertMsg"
            @reset="alertValue = false"
          />
          <v-card-text class="pt-0 pl-6">
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="py-15 px-md-12">
                  <p class="font-weight-bold text-h6 darktext--text">
                    {{ $t('labelFirstName') }}
                  </p>
                  <v-text-field
                    v-model="firstName"
                    data-testid="first-name-input"
                    solo
                    hide-details="auto"
                    elevation="6"
                    class="first_name rounded-xxl text-body-2 mb-5"
                    :rules="firstNameRules"
                  />
                  <p class="font-weight-bold text-h6 darktext--text">
                    {{ $t('labelLastName') }}
                  </p>
                  <v-text-field
                    v-model="lastName"
                    data-testid="last-name-input"
                    solo
                    hide-details="auto"
                    elevation="6"
                    class="last_name rounded-xxl text-body-2 mb-5"
                    :rules="lastNameRules"
                  />
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-form>
      </v-card>
    </v-dialog>
  </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import { updateUser } from '../../api/userApi'
import { ruleRequired, ruleValidMin2Max70Characters } from '../../rules/formRules.js';
import AlertMessages  from '../../components/AlertMessages'

export default {
    components: {
        AlertMessages
    },
    data(){
        return{
            dialog: false,
            valid: true,
            firstName: localStorage.user ? JSON.parse(localStorage.user).first_name : '',
            lastName: localStorage.user ? JSON.parse(localStorage.user).last_name : '',
            canEditProfile: localStorage.user ? JSON.parse(localStorage.user).can_edit_profile : true,
            firstNameRules: ruleRequired('labelFirstName').concat(ruleValidMin2Max70Characters('labelFirstName')),
            lastNameRules: ruleRequired('labelLastName').concat(ruleValidMin2Max70Characters('labelLastName')),
            alertMsg: '',
            alertValue:false,
            userId: window.$cookies.get('id'),
            loading: false,
         }
    },
    methods: {
        async updateFirstLastName(){
            this.$refs.form.validate()
            if(this.valid){
                this.loading = true

                var alertType = ''
                var alertMsg = ''
                try {
                    let data = {
                        data: {
                            type: "users", 
                            id: this.userId,
                            attributes: {
                                first_name: this.firstName.trim(),
                                last_name: this.lastName.trim(),
                            }
                        }
                    };
                    const response = await updateUser(this.userId, data)
                    if(response.status == 200) {
                        
                       alertMsg =  i18n.t('editUserSuccess')
                        alertType = 'success'
                        this.$emit('proceedSubmit', alertMsg, alertType)
                        this.$emit('proceedFirstLastName', response.data.data.attributes)
                    }
                } catch (e) {
                    if(e.response){
                        this.alertValue = true
                        alertType = 'error'
                        alertMsg =  i18n.t('serverError')
                        this.$emit('proceedSubmit', alertMsg, alertType)
                    }
                }
                this.loading = false
                this.dialog = false
            }
        },
        reloadForm(){
            this.dialog = false,
            this.alertMsg = ''
            this.firstName= localStorage.user ? JSON.parse(localStorage.user).first_name : ''
            this.lastName= localStorage.user ? JSON.parse(localStorage.user).last_name : ''
        }
    }
}
</script>